import React, { useState } from "react";
import { Listbox } from "@headlessui/react";
import { Paperclip, X } from "lucide-react";
import {
  ChevronUpDownIcon,
  ChevronUpIcon,
  ChevronDownIcon,
} from "@heroicons/react/20/solid";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";


const subscriptionOptions = [
  { name: "Per Per Contact" },
  { name: "Monthly 50" },
  { name: "Yearly 500" },
];
const statusOptions = [
  { name: "Active" },
  { name: "On Hold" },
  { name: "Premium" },
  { name: "Deactivate" },
];
const countries = [
  { name: "India", flag: "https://flagcdn.com/48x36/in.png" },
  { name: "France", flag: "https://flagcdn.com/48x36/fr.png" },
  { name: "Portugal", flag: "https://flagcdn.com/48x36/pt.png" },
  { name: "Argentina", flag: "https://flagcdn.com/48x36/ar.png" },
];
const Hierarchy = [
  { name: "Owner" },
  { name: "Shareholder" },
  { name: "Director" },
  { name: "Decision Makers" },
  { name: "Department Head" },
  { name: "Executives" },
];
const Messages = [
  { name: "Whatsapp" },
  { name: "WeChat" },
  { name: "Director" },
  { name: "Facebook Messenger" },
  { name: "Telegram" },
  { name: "Snapchat" },
];
const Messagess = [
  { name: "Whatsapp" },
  { name: "WeChat" },
  { name: "Director" },
  { name: "Facebook Messenger" },
  { name: "Telegram" },
  { name: "Snapchat" },
];
const Currency = [{ name: "USD" }, { name: "Euro" }, { name: "INR" }];
const Company = [
  { name: "Individual" },
  { name: "Single Man Company" },
  { name: "Proprietorship" },
  { name: "PartnerShip" },
  { name: "Public Limited" },
  { name: "Private Limited" },
];
const Revenue = [
  { name: "1 to 10 million USD" },
  { name: "Less than 1 million USD" },
  { name: "50 to 100 million USD" },
  { name: "more than 100 milion USD" },
];
const Employees = [
  { name: "(1 to 10 employees)" },
  { name: "(10 to 20 employees)" },
  { name: "(21 to 100 employees)" },
  { name: "(100 to 500 employees)" },
];

export default function AddBuyerDetails({ setActiveTab }) {
  const [selectedStatus, setSelectedStatus] = useState(statusOptions[0]);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedHierachy, setSelectedHierachy] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState("");
  const [openMessage, setOpenMessage] = useState(false);
  const [selectedMessagess, setSelectedMessagess] = useState("");
  const [openMessages, setOpenMessages] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [openCurrency, setOpenCurrency] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [openCompany, setOpenCompany] = useState(false);
  const [selectedRevenue, setSelectedRevenue] = useState("");
  const [openRevenue, setOpenRevenue] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [openEmployee, setOpenEmployee] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [pendingOption, setPendingOption] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showAssignmentForm, setShowAssignmentForm] = useState(false);
  const [assignedTo, setAssignedTo] = useState("");
  const [isOpenPriority, setIsOpenPriority] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState("");
  const priorities = ["Low", "Medium", "High"];

  const handleAssignToMe = () => {
    setAssignedTo("Current User");
    setShowAssignmentForm(false);
  };
  const handleSelectMessage = (message) => {
    setSelectedMessages(`${message.name}`);
    setOpenMessage(false);
  };
  const handleSelectCurrency = (currency) => {
    setSelectedCurrency(`${currency.name}`);
    setOpenCurrency(false);
  };
  const handleSelectEmployee = (employee) => {
    setSelectedEmployee(`${employee.name}`);
    setOpenEmployee(false);
  };
  const handleSelectRevenue = (revenue) => {
    setSelectedRevenue(`${revenue.name}`);
    setOpenRevenue(false);
  };
  const handleSelectCompany = (company) => {
    setSelectedCompany(`${company.name}`);
    setOpenCompany(false);
  };
  const handleSelectMessages = (message) => {
    setSelectedMessagess(`${message.name}`);
    setOpenMessages(false);
  };
  const handleSelectHierachy = (item) => {
    setSelectedHierachy(`${item.name}`);
    setOpen(false);
  };
  const handleSelect = (country) => {
    setSelectedCountry(`${country.flag} ${country.name}`);
    setShowDropdown(false);
  };
  const navigate = useNavigate();
  const handleIconClick = () => {
    navigate("/select-assignee");
  };
  const confirmChange = () => {
    setShowConfirmation(false);
    setTimeout(() => {
      setSelectedStatus(pendingOption);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    }, 500);
  };
  const cancelChange = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="container  mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div className="flex flex-col items-center justify-evenly sm:flex-row gap-4 mt-4 w-full">
          <div className="bg-blue-500 text-white px-4 py-2 rounded shadow-md flex items-center justify-center w-full sm:w-auto">
            <span className="font-normal text-sm sm:text-base">
              Sellable Price of this Buyer in INR:
            </span>
            <span className="ml-2 font-normal">₹ 0</span>
          </div>
          <div className="bg-blue-500 text-white px-4 py-2 rounded shadow-md flex items-center justify-center w-full sm:w-auto">
            <span className="font-normal text-sm sm:text-base">
              Sellable Price of this Buyer in USD:
            </span>
            <span className="ml-2 font-normal">$ 0</span>
          </div>
      </div>

      
          {/* Buyer seller details */}
      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-lg w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Product Seller Details
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Email<span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              placeholder="Enter your Email Address"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Mobile<span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              placeholder="Enter Mobile Number"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>

          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Status<span className="text-red-500">*</span>
            </label>
            <Listbox
              value={selectedStatus}
              onChange={(option) => {
                if (option.name !== selectedStatus.name) {
                  setPendingOption(option);
                  setShowConfirmation(true);
                }
              }}
            >
              <div className="relative">
                <Listbox.Button className="w-full bg-green-100 border border-gray-300 rounded-lg px-3 py-2 flex justify-between items-center text-sm sm:text-base">
                  {selectedStatus.name}
                  <ChevronUpDownIcon className="h-5 w-5 text-gray-500" />
                </Listbox.Button>
                <Listbox.Options className="absolute mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-h-60 overflow-auto">
                  {statusOptions.map((option, idx) => (
                    <Listbox.Option
                      key={idx}
                      value={option}
                      className="cursor-pointer px-4 py-2 hover:bg-gray-100 flex justify-center text-sm sm:text-base"
                    >
                      {option.name}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </div>
            </Listbox>
            {showConfirmation && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg w-full max-w-sm">
                  <div className="bg-red-500 text-white text-3xl sm:text-4xl mb-4 border-4 border-red-500 rounded-full w-12 h-12 flex items-center justify-center mx-auto">
                    ?
                  </div>
                  <h3 className="text-base sm:text-lg text-gray-800 mb-4 text-center">
                    Are you sure you want to change the buyer status to {pendingOption?.name}?
                  </h3>
                  <div className="flex justify-center space-x-3">
                    <button
                      onClick={cancelChange}
                      className="px-4 py-2 border border-red-500 text-red-500 rounded text-sm sm:text-base"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={confirmChange}
                      className="px-6 sm:px-10 py-2 bg-red-500 text-white rounded text-sm sm:text-base"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            )}
            {showSuccess && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
                <div className="bg-white rounded-lg p-4 sm:p-6 w-full max-w-sm text-center">
                  <div className="bg-red-500 text-white text-3xl sm:text-4xl mb-4 border-4 border-red-500 rounded-full w-12 h-12 flex items-center justify-center mx-auto">
                    ✓
                  </div>
                  <p className="mb-4 text-gray-800 text-sm sm:text-base">
                    The buyer status has been successfully changed to {pendingOption?.name}. ✅
                  </p>
                  <button
                    onClick={() => setShowSuccess(false)}
                    className="py-1 px-6 sm:px-8 rounded-md border text-white bg-red-500 font-medium text-sm sm:text-base"
                  >
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Present Subscription<span className="text-red-500">*</span>
            </label>
            <Listbox
              value={selectedSubscription}
              onChange={setSelectedSubscription}
            >
              {({ open }) => (
                <div className="relative">
                  <Listbox.Button className="w-full bg-white border border-gray-300 rounded-lg px-3 py-2 flex justify-between items-center text-sm sm:text-base">
                    {selectedSubscription
                      ? selectedSubscription.name
                      : "Select Present Subscription"}
                    {open ? (
                      <ChevronUpIcon className="h-5 w-5 text-gray-500" />
                    ) : (
                      <ChevronDownIcon className="h-5 w-5 text-gray-500" />
                    )}
                  </Listbox.Button>
                  <Listbox.Options className="absolute mt-1 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-10 max-h-60 overflow-auto">
                    {subscriptionOptions.map((option, idx) => (
                      <Listbox.Option
                        key={idx}
                        value={option}
                        className="cursor-pointer px-4 py-2 hover:bg-gray-100 text-gray-600 text-sm sm:text-base"
                      >
                        {option.name}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </div>
              )}
            </Listbox>
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Product Seller Management Details
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Added By
            </label>
            <input
              type="text"
              placeholder="Administrator"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Added Date
            </label>
            <input
              type="text"
              placeholder="12/11/2025"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Source<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select Product Seller Source"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Stage<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select Product Seller Stage"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Last Updates By
            </label>
            <input
              type="text"
              placeholder="Executives"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Next Step<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select Next Step"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Owner<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select Owner"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Product Seller Recommended For<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select Recommended Role"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Tags<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Tags"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Assigned To<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select"
              onClick={() => setShowAssignmentForm(true)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base cursor-pointer"
            />
            <ChevronDownIcon
              onClick={() => setShowAssignmentForm(true)}
              className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none"
            />
          </div>
        </div>
        {showAssignmentForm && (
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-4 sm:p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg sm:text-xl font-normal">Assigned To</h3>
                <button onClick={() => setShowAssignmentForm(false)}>
                  <X className="w-5 h-5 text-gray-900" />
                </button>
              </div>
              <div className="flex items-center mb-4">
                <input type="checkbox" className="w-4 h-4" />
                <div className="ml-3 text-sm sm:text-base">Assign to me</div>
              </div>
              <div>
                <label className="block font-normal text-gray-700 mb-1 text-sm sm:text-base">
                  Assign To<span className="text-red-500">*</span>
                </label>
                <textarea
                  placeholder="Enter assign to"
                  className="w-full min-h-[50px] border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  bg-gray-100 text-sm sm:text-base"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                <div>
                  <label className="block font-normal text-gray-700 mb-1 text-sm sm:text-base">
                    Completed By
                  </label>
                  <input
                    type="text"
                    placeholder="Select date"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  bg-gray-100 text-sm sm:text-base"
                  />
                </div>
                <div>
                  <label className="block font-normal text-gray-700 mb-1 text-sm sm:text-base">
                    Priority
                  </label>
                  <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  bg-gray-100 text-sm sm:text-base">
                    <option>Select Priority</option>
                    {priorities.map((priority) => (
                      <option key={priority} value={priority}>
                        {priority}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-4">
                <label className="block font-normal text-gray-700 mb-1 text-sm sm:text-base">
                  Comments
                </label>
                <textarea
                  placeholder="write ..."
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  bg-gray-100 text-sm sm:text-base"
                />
              </div>
              <div className="flex justify-end mt-4">
                <button className="bg-blue-600 text-white py-2 px-5 rounded-lg hover:bg-blue-700 text-sm sm:text-base">
                  Assign
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Basic Details
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Company ID<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="LBINXXXX"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Company Name<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Company Name or Web URL"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Company Website URL
            </label>
            <input
              type="text"
              placeholder="Enter Company Website URL"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Nature of Business<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Select Nature of Business"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Primary Email Id<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Email Id"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Additional Email Id
            </label>
            <input
              type="text"
              placeholder="Enter Additional Email Id"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Primary Contact Number<span className="text-red-500">*</span>
            </label>
            <div className="flex">
              <span className="inline-flex items-center px-3 py-2 rounded-l-md border border-gray-300 bg-gray-100 text-gray-500 text-sm">
                +91
              </span>
              <input
                type="text"
                placeholder="Enter Primary Contact No."
                className="flex-1 border border-gray-300 rounded-r-md px-3 py-2 focus:outline-none  text-sm sm:text-base"
              />
            </div>
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Additional Contact Number (Separated By ( ; ) )
            </label>
            <input
              type="text"
              placeholder="Enter Additional Contact No"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Company LinkedIn URL
            </label>
            <input
              type="text"
              placeholder="Enter Company LinkedIn URL"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Geo Details
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Country<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={selectedCountry}
              onClick={() => setShowDropdown(!showDropdown)}
              readOnly
              placeholder="Select Your Country"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {showDropdown && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {countries.map((country) => (
                  <li
                    key={country.name}
                    onClick={() => handleSelect(country)}
                    className="px-4 py-2 hover:bg-gray-100 font-normal cursor-pointer text-gray-600 flex items-center gap-2 text-sm sm:text-base"
                  >
                    <img src={country.flag} alt={country.name} className="w-5 h-4 object-cover" />
                    {country.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              State<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your State"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              City/District
            </label>
            <input
              type="text"
              placeholder="Enter Your City"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Locality<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Locality"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Street<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Street"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 mt-2">
              <button className="px-4 py-1 bg-blue-500 text-white rounded text-sm shadow">
                Add More
              </button>
              <button
                className="px-4 py-1 bg-gray-200 text-gray-500 rounded text-sm shadow"
                disabled
              >
                Add Fields
              </button>
            </div>
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Pin Code
            </label>
            <input
              type="text"
              placeholder="Enter Your Pin Code"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Executives
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Name<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Name"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Designation<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Designation"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Organizational Hierarchy<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedHierachy}
              onClick={() => setOpen(!open)}
              placeholder="Select Your Organizational Hierarchy"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {open && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Hierarchy.map((item) => (
                  <li
                    key={item.name}
                    onClick={() => handleSelectHierachy(item)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {item.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Email ID<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Email ID"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Primary Contact Number<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Primary Contact Number"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none ext-sm sm:text-base"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Additional Contact Number (Separated by( ; ))
            </label>
            <input
              type="text"
              placeholder="Enter Additional Contact No"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Preferred Instant Message - 1<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedMessages}
              onClick={() => setOpenMessage(!openMessage)}
              placeholder="Select your Preferred Messages-1"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {openMessage && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Messages.map((message) => (
                  <li
                    key={message.name}
                    onClick={() => handleSelectMessage(message)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {message.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Preferred Instant Message - 1 ID
            </label>
            <input
              type="text"
              placeholder="Enter Your Preferred Message -1 ID"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Preferred Instant Message - 2<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedMessagess}
              onClick={() => setOpenMessages(!openMessages)}
              placeholder="Select your Preferred Messages-2"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {openMessages && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Messagess.map((messages) => (
                  <li
                    key={messages.name}
                    onClick={() => handleSelectMessages(messages)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {messages.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Preferred Instant Message - 2 ID
            </label>
            <input
              type="text"
              placeholder="Enter Your Preferred Message -2 ID"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Personal LinkedIn Page
            </label>
            <input
              type="text"
              placeholder="Enter Your Personal LinkedIn Page"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  text-sm sm:text-base"
            />
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 mt-2">
              <button className="px-4 py-1 bg-blue-500 text-white rounded text-sm shadow">
                Add More
              </button>
              <button
                disabled
                className="px-4 py-1 bg-gray-200 text-gray-500 rounded text-sm shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Other Business Details
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Tax ID<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Your Tax ID"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Preferred Currency<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedCurrency}
              onClick={() => setOpenCurrency(!openCurrency)}
              placeholder="Select your Preferred Currency"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {openCurrency && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Currency.map((currency) => (
                  <li
                    key={currency.name}
                    onClick={() => handleSelectCurrency(currency)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {currency.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Type of Company<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedCompany}
              onClick={() => setOpenCompany(!openCompany)}
              placeholder="Select your Type Of Company"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {openCompany && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Company.map((company) => (
                  <li
                    key={company.name}
                    onClick={() => handleSelectCompany(company)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {company.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Year of Incorporation<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Year of Incorporation"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            />
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Yearly Revenue<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedRevenue}
              onClick={() => setOpenRevenue(!openRevenue)}
              placeholder="Select Yearly Revenue"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {openRevenue && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Revenue.map((revenue) => (
                  <li
                    key={revenue.name}
                    onClick={() => handleSelectRevenue(revenue)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {revenue.name}
                  </li>
                ))}
              </ul>
            )}
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
          <div className="relative">
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Number Of Employees<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              readOnly
              value={selectedEmployee}
              onClick={() => setOpenEmployee(!openEmployee)}
              placeholder="Select No.of.employees"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none  cursor-pointer text-sm sm:text-base"
            />
            <ChevronDownIcon className="absolute right-3 top-9 w-5 h-5 text-gray-400 pointer-events-none" />
            {openEmployee && (
              <ul className="absolute z-10 mt-1 w-full bg-white border rounded-lg shadow max-h-60 overflow-auto">
                {Employees.map((employee) => (
                  <li
                    key={employee.name}
                    onClick={() => handleSelectEmployee(employee)}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-gray-600 text-sm sm:text-base"
                  >
                    {employee.name}
                  </li>
                ))}
              </ul>
            )}
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Files Attachments
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Attach Company Logo<span className="text-red-500">*</span>
            </label>
            <div className="flex items-center border rounded-lg px-2 py-1 w-full">
              <label className="flex items-center bg-gray-200 px-3 py-1 rounded-lg cursor-pointer">
                <Paperclip size={16} className="mr-2 text-gray-600" />
                <span className="text-sm text-gray-700">Attachments</span>
                <input type="file" className="hidden" />
              </label>
            </div>
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Attach Other files relevant to Your Business Promotion<span className="text-red-500">*</span>
            </label>
            <div className="flex items-center border rounded-lg px-2 py-1 w-full">
              <label className="flex items-center bg-gray-200 px-3 py-1 rounded-lg cursor-pointer">
                <Paperclip size={16} className="mr-2 text-gray-600" />
                <span className="text-sm text-gray-700">Attachments</span>
                <input type="file" className="hidden" />
              </label>
            </div>
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white border-2 border-gray-200 rounded-lg p-4 sm:p-6 mt-6 mx-auto shadow-sm w-full">
        <h2 className="text-lg sm:text-xl text-gray-800 font-semibold mb-4 underline text-center sm:text-left">
          Security
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Password<span className="text-red-500">*</span>
            </label>
            <div className="relative flex items-center border rounded-lg px-3 py-2 w-full">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                className="w-full outline-none text-sm sm:text-base text-gray-700"
              />
              <div
                onClick={() => setShowPassword(!showPassword)}
                className="cursor-pointer"
              >
                {showPassword ? (
                  <EyeSlashIcon className="w-4 h-4 text-gray-700" />
                ) : (
                  <EyeIcon className="w-4 h-4 text-gray-700" />
                )}
              </div>
            </div>
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
          <div>
            <label className="block font-medium text-gray-700 mb-1 text-sm sm:text-base">
              Confirm Password<span className="text-red-500">*</span>
            </label>
            <div className="relative flex items-center border rounded-lg px-3 py-2 w-full">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm your password"
                className="w-full outline-none text-sm sm:text-base text-gray-700"
              />
              <div
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="cursor-pointer"
              >
                {showConfirmPassword ? (
                  <EyeSlashIcon className="w-4 h-4 text-gray-700" />
                ) : (
                  <EyeIcon className="w-4 h-4 text-gray-700" />
                )}
              </div>
            </div>
            <div className="mt-2 flex justify-end">
              <button
                disabled
                className="px-4 py-1 text-sm bg-gray-200 text-gray-500 rounded shadow"
              >
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 sm:mt-10 flex justify-end px-4 sm:px-6">
        <button
          onClick={() => setActiveTab("products")}
          className="bg-red-600 px-6 sm:px-10 py-2 text-white rounded shadow hover:bg-red-700 text-sm sm:text-base"
        >
          Next
        </button>
      </div>
    </div>
  );
}
